// extracted by mini-css-extract-plugin
export default {"mainWrapper":"eaJEU ZdH1P","breadcrumbs":"kQwl7","menu":"Q8AVt","banner":"aytQa","scrolling":"gikKV","hidden":"szOCA","content":"KzFUo","withBanner":"wd4v5","bannerHelper":"T_p5q"};